module.exports = __webpack_public_path__ + "static/img/circle-red@2x.49618e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Prototypes/Visual/Woody/Texture/circle-red@2x.png
// module id = 521
// module chunks = 0